(function GroupIndex($, Adzuki)
{
	"use strict";

	Adzuki.onload(['Reservations/manageComponents'], init, false);

	Adzuki.onload('Groups/manage', function onload()
	{
		var $modal      = $(".modal"),
			modal_title = $('#popup_comment').data("modal-title"),
			modal_body  = $('#popup_comment').data("modal-body");

		if ($('#popup_comment').length) {
			$modal.addClass('wide');
			$modal.find('.modal-body').html(modal_body);
			$modal.find('.modal-title').text(modal_title);

			$modal.modal('show');
		}

		// change group agent
		$('.group-agent').click(function showGroupAgentDropDown(e) {
			e.preventDefault();

			$('.current-group-agent').addClass('hidden');
			$('.agent-list').removeClass('hidden');
		});

		$('.reset-group-agent-selection').click(function resetBookingAgentSelection(e) {
			e.preventDefault();

			$('.agent-list').addClass('hidden');
			$('.current-group-agent').removeClass('hidden');
		});

		$('#group-agent-selection').change(changeGroupAgent);
	});

	Adzuki.onload('Groups/manageEmails', function onload()
	{
		$('.sent-email, .queued-email').click(function showEmail(e) {
			var $self          = $(this),
			    $modal         = $(".modal"),
			    modal_title    = $self.data("modal-title"),
			    iframe_src     = $self.data("iframe-src"),
			    iframe_height  = $self.data("iframe-height") || 500,
			    iframe_width   = $self.data("iframe-width") || '100%';

			e.preventDefault();

			$modal.addClass('wide');

			$modal.find('iframe').attr({
				src   : iframe_src,
				height: iframe_height,
				width : iframe_width
			});

			$modal.find('.modal-title').text(modal_title);
			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		});
	});

	Adzuki.onload('Groups/manageComments', function onload()
	{
		$('.comment').click(function showComment(e) {
			var $self         = $(this),
			    $modal        = $(".modal"),
			    comment_id    = $self.data("comment-id"),
			    modal_title   = $self.data("modal-title");

			e.preventDefault();

			$modal.addClass('wide');
			$modal.find('.modal-body').text('Loading comment...');

			Adzuki.Ajax.get('/GroupComments/view/' + comment_id)
				.then(function _showComment(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
			});

			$modal.find('.modal-title').text(modal_title);
			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		});
	});

	$(document).ready(function documentReady()
	{
		// manage attachments screen
		Adzuki.onload('/GroupAttachments/index', function onload()
		{
			$('.task-details').off().on('click', _openTaskDetails);
		});

		// manage tasks screen
		Adzuki.onload('Groups/manageTasks', function onload()
		{
			Adzuki.TaskManager.loadEntityTasks('group');
		});

		// group component category sort
		Adzuki.onload('/GroupCategories/sort/', function onload()
		{
			dragula([$('.component-categories')[0]], {
				revertOnSpill: true,
			})
			.on('drop', function dropIt(this_el, target, source, sibling)
			{
				handleCategorySortOrder();
			});
		});

		// manage texts screen
		Adzuki.onload('Groups/manageTexts', function onload() {
			$('.view-text-message').on('click', _viewTextMessage);
		});
	});

	function init()
	{
		$('.view-group-reservations').on('click', showGroupReservations);
	}

	function showGroupReservations(e)
	{
		var $modal     = $(".modal"),
			group_id   = $(this).data('group-id'),
			group_type = $(this).data('group-type'),
			url;

		e.preventDefault();

		if (group_type === 'private') {
			url = '/Groups/reservations/' + group_id + '/1';
		} else {
			url = '/GroupsHo/reservations/' + group_id + '/1';
		}

		$modal.addClass('wide');
		$modal.find('.modal-body').text('Loading Group Reservations...');

		Adzuki.Ajax.get(url)
		.then(function success(html) {
			$modal.find('.modal-body').html(html);
		});

		$modal.find('.modal-title').text('Group Reservations');
		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal');
		}).modal('show');
	}

	function handleCategorySortOrder() {
		var sort_order   = '',
			component_id = '',
			counter      = 1,
			cur_html     = '',
			html_parts   = '';

		$('.component-category:not(.gu-mirror)').each(function groupComponentCategoryProcessSort() {
			sort_order   += $(this).data('id') + ',';
			component_id = $(this).data('component_id');
		});

		Adzuki.Ajax.get('/GroupCategories/processSort/' + component_id + '/' + sort_order).then(function success(response) {
			$('.component-category').each(function assignNumbers() {
				cur_html   =  $(this).html();
				html_parts = cur_html.split('.');

				$(this).html(counter + '. ' + html_parts[1]);
				counter++;
			});

			Adzuki.StatusMessage(null, 'Sort order has been saved', 'Sort Saved');
		});
	}

	function changeGroupAgent() {
		var group_id   = $(this).data("group-id"),
			agent_id   = $(this).val(),
			agent_name = $('#group-agent-selection option:selected').text();

		$('.reset-group-agent-selection').addClass('hidden');
		$('.group-agent-working').removeClass('hidden');

		Adzuki.Ajax.get('/Groups/updateGroupAgent/' + group_id + '/' + agent_id)
			.then(function _updateGroupAgent(html) {
				$('.current-group-agent-name').html(agent_name);
				$('#group-agent-selection').replaceWith(html);
				$('#group-agent-selection').change(changeGroupAgent);

				$('.agent-list').addClass('hidden');
				$('.current-group-agent').removeClass('hidden');
				$('.group-agent-working').addClass('hidden');
				$('.reset-group-agent-selection').removeClass('hidden');
		});
	}

	function _openTaskDetails(e)
	{
		var $anchor_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.openTaskDetails($anchor_elem);
	}

	function _viewTextMessage(e)
	{
		var group_text_message_id = $(this).data('group-text-message-id');
		var $modal                = $('.modal');

		e.preventDefault();

		$modal.modal('show');
		$modal.find('.modal-title').text('Group Text Message');
		$modal.find('.modal-body').text('Loading text message...');

		Adzuki.Ajax.get('/GroupTexts/view/' + group_text_message_id)
		.then(function viewTextMessage(response) {
				$modal.find('.modal-body').html(response);
		});
	}
}(jQuery, window.Adzuki || {}));
